'use strict';

/**
* @desc new load embedded media script, it lazyloads embedded media
* html example
* js init example: novicell.embed.loadEmbeds();
* js scroll example:
* if ($('.embed-media-item').length > 0) {
*     novicell.embed.loadEmbeds();
* }
* @author Tommy Pedersen - TPE
* @return generates preplay image
* @requires jquery@1.11.3
* @note: Just beautiful!
*/

var novicell = novicell || {};

novicell.embed = novicell.embed || function () {
	var lastRefreshWidth = 0;
	var refreshWidth = 50;

	function loadEmbeds(callback) {
		$("section.embed-media.embed-media--not-loaded").each(function () {
			if ($(this).visible(true) || $(this).data("load") === "always") {
				$(this).removeClass('embed-media--not-loaded').addClass('embed-media--loaded');
				if ($(this).has(".embed-media__still").length) {
					$(this).find(".embed-media__still").click(function () {
						lazyEmbed($(this).parent().find(".embed-media__item"),true);
						$('body').addClass('body-video-overlay-open')
						if (typeof callback == 'function') {
							callback();
						}
					});
					$(this).find(".embed-media__close").click(function () {
						$(this).closest('.embed-media__item').attr("style", "display: none!important");
						$('body').removeClass('body-video-overlay-open')
						var videoItem = $(this).closest('.embed-media__item');
						//toggleVideo(videoItem)
						$(this).closest('.embed-media__item').find('iframe').attr('src','');
					});

				} else {
					lazyEmbed($(this).find(".embed-media__item"),false);
					if (typeof callback == 'function') {
						callback();
					}
				}
			}
		});
	}

	function onResize(callback) {
		if (window.innerWidth > lastRefreshWidth + refreshWidth || window.innerWidth < lastRefreshWidth - refreshWidth) {
			$('section.embed-media').each(function () {
				//lazyEmbed($(this).find(".embed-media__item"),false);
				if (typeof callback == 'function') {
					callback();
				}
			});
			lastRefreshWidth = window.innerWidth;
		}
	}

	function lazyEmbed(figure,addAutoplay) {
		figure.attr("style", "display: block!important");
		figure.addClass('embed-media__item--loaded');
		var $embed = figure.find(".embed");
		var ratio, src, width;
		width = figure.width() !== 0 ? figure.width() : $(figure).parent().width();
		ratio = $embed.data("ratio");
		src = $embed.data("src");
		$embed.attr("src", src);
		$embed.attr("width", width);
		$embed.attr("height", width * ratio);

		if(addAutoplay===true){$embed.attr("src", updateQueryStringParameter($embed.data("src"), "autoplay", "true"));}
	}

	function backofficeEmbeds(callback) {
		$("section.embed-media").each(function () {
			$(this).find(".embed-media__still").remove();
			lazyEmbed($(this).find(".embed-media__item"),false);
			$(this).find(".embed").attr("src", updateQueryStringParameter($(this).find(".embed").data("src"), "autoplay", "false"));
			if (typeof callback == 'function') {
				callback();
			}
		});
	}

	function updateQueryStringParameter(uri, key, value) {
		var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
		var separator = uri.indexOf('?') !== -1 ? "&" : "?";
		if (uri.match(re)) {
			return uri.replace(re, '$1' + key + "=" + value + '$2');
		}
		else {
			return uri + separator + key + "=" + value;
		}
	}

	// public functions:
	return {
		loadEmbeds: loadEmbeds,
		backofficeEmbeds: backofficeEmbeds,
		onResize: onResize
	};
}();





function toggleVideo(videoItem) {
    var sectionTag = $(videoItem);
    var iframe = sectionTag.getElementsByTagName("iframe")[0].contentWindow;
    //sectionTag.style.display = state == 'hide' ? 'none' : '';
    func = 'pauseVideo';
    iframe.postMessage('{"event":"command","func":"' + func + '","args":""}', '*');
}